// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"cookies_contentWrapper__fpPjr","link":"cookies_link__LK0mr","btn":"cookies_btn__OuGJD","altPosition":"cookies_altPosition__9SBRK"};